module.exports = __webpack_public_path__ + "img/arrow.139b9fbe.svg";